export const LOTTERY_TYPE_SEARCH_PARAM = "lotteryType";
